import axios from 'axios'

export function fetchActivePaymentTerms() {
    return axios.get('/api/company/payment-terms/active')
        .then((res) => {
            if (res.data.status === 'success') {
                return res.data.payment_terms
            }

            return []
        })
        .catch(() => [])
}

export function paymentTermsToFilterOptions(terms) {
    return terms.map((term) => ({
        id: term,
        label: term,
    }))
}
